@if (paramMap$ | async; as paramMap) {
	<stages-dialog2 [dialogAriaLabel]="paramMap !== null ? getMessageKeyForDialog(paramMap) : 'Files Add Dialog'" #dialog>
		<stages-dialog-header />
		@if (credentialsValid) {
			@if (fileProperties$ | async; as fileProperties) {
				<span class="h1" translate="{{ getMessageKeyForAdd(paramMap, fileProperties) }}"></span>
				<form [formGroup]="uploadForm" class="content file-add-dialog" name="uploadForm" novalidate #formElement>
					<stages-upload
						[uploadCompletedCallback]="getUploadCompletedCallback(fileProperties)"
						[uploadUrl]="uploadUrl"
						[multiple]="paramMap.get('singleFile') !== 'true'"
						(uploadError)="handleError($event)"
					></stages-upload>
					@if (errorMessage) {
						<div class="error hint">
							<span>{{ errorMessage }}</span>
						</div>
					}
					@if (addFilesUpload.length) {
						<article class="new-files">
							<header>
								<span class="h5" translate="files.add.files"></span>
							</header>
							<ul class="list dense" formArrayName="addFiles">
								@for (addFileControl of addFiles.controls; track addFileControl; let i = $index) {
									<li class="list-item column-style">
										<div class="label">
											<div class="icon-spacer">
												<i class="ico ico-file"></i>
											</div>
											<input
												type="text"
												class="text"
												required
												[formControlName]="i"
												autocomplete="off"
												(keydown.enter)="onEnter($event, fileProperties, paramMap)"
											/>
											<button
												[attr.title]="'delete' | translate"
												[attr.aria-label]="'delete' | translate"
												(click)="deleteUpload(addFilesUpload[i].uploadId, paramMap)"
												class="action clickable"
											>
												<i class="ico ico-delete"></i>
											</button>
										</div>
										<div class="label info">
											@if (
												hasAlreadyIncludedWarning($any(addFileControl)) ||
												(!uploadForm.valid && (addFileControl.dirty || addFileControl.touched))
											) {
												<div class="errors">
													@if (
														addFileControl.errors &&
														!uploadForm.valid &&
														(addFileControl.dirty || addFileControl.touched)
													) {
														@if (addFileControl.errors["required"]) {
															<div class="error" translate="input.required"></div>
														}
														@if (addFileControl.errors["max"]) {
															<div class="error" translate="input.maxLength" [translateParams]="{ length: 255 }"></div>
														}
														@if (addFileControl.errors["alreadySelected"]) {
															<div class="error" translate="input.alreadySelected"></div>
														}
													}
													@if (hasAlreadyIncludedWarning($any(addFileControl))) {
														<div class="error info" translate="input.alreadyIncluded"></div>
													}
												</div>
											}
											<div class="maxlength">{{ addFileControl.value.length }}/255</div>
										</div>
									</li>
								}
							</ul>
						</article>
					}
					@if (updateFilesUpload.length) {
						<article class="new-versions">
							<header>
								<span class="h5" translate="files.add.versions"></span>
							</header>
							<p class="hint" translate="files.add.versions.message"></p>
							<ul class="list dense" formArrayName="updateFiles">
								@for (updateFilesControl of updateFiles.controls; track updateFilesControl; let i = $index) {
									<li class="list-item">
										<i class="ico ico-file"></i>
										<div class="text">
											<input type="hidden" [formControlName]="i" stagesFiletype="{{ getFileType(fileProperties) }}" />
											<span class="h4">{{ updateFilesControl.value }}</span>
											<p translate="files.add.versions.of" [translateParams]="{ name: getUpdateFilename(i) }"></p>
											<div class="errors">
												@if (!uploadForm.valid && (updateFilesControl.dirty || updateFilesControl.touched)) {
													@if (updateFilesControl.errors!["filetype"]) {
														<div
															class="error"
															translate="input.typeMismatch"
															[translateParams]="{ filetype: fileProperties.fileType }"
														></div>
													}
													@if (updateFilesControl.errors!["alreadySelected"]) {
														<div class="error" translate="input.alreadySelected"></div>
													}
												}
											</div>
										</div>
										<button
											[attr.title]="'delete' | translate"
											[attr.aria-label]="'delete' | translate"
											(click)="deleteUpload(updateFilesUpload[i].uploadId, paramMap)"
											class="action clickable"
										>
											<i class="ico ico-delete"></i>
										</button>
									</li>
								}
							</ul>
						</article>
					}
					<article class="form properties">
						<stages-attribute-edit
							[attributeTypes]="fileProperties.attributeTypes"
							[attributes]="fileProperties.attributes"
							[form]="uploadForm"
							(change)="hasFormChanges(fileProperties)"
						>
						</stages-attribute-edit>
						@if (isNotifyUsersAllowed(fileProperties)) {
							<div class="input-container">
								<label for="notify" class="input-label" translate="files.notification.notify.users"></label>
								<div>
									<input
										type="checkbox"
										hidden="hidden"
										id="notify"
										name="notify"
										[checked]="notifyUsers"
										(change)="showNotificationOptions()"
									/>
									<label for="notify" class="switch"></label>
								</div>
							</div>
						}
					</article>
					@if (notifyUsers) {
						<stages-files-notifications
							(notificationInformation)="setNotificationInformation($event)"
							[isNewFile]="true"
						>
						</stages-files-notifications>
					}
				</form>
				<footer>
					<div class="buttons">
						<button class="button sm cancel" translate="cancel" (click)="dialog.close()"></button>
						<button
							class="button sm save"
							[disabled]="saveButtonDisabled(paramMap)"
							(click)="saveClicked(fileProperties)"
						>
							@if (!saveInProgress) {
								<span translate="files.start.upload.button"></span>
							}
							@if (saveInProgress) {
								<stages-spin size="s"></stages-spin>
							}
						</button>
					</div>
				</footer>
			} @else {
				@if (loadingError$ | async; as error) {
					<span class="h1" translate="error.title"></span>
				}
				<stages-popup-content>
					<stages-loading-error-embeddable [credentialsValid]="credentialsValid" [loadingError$]="loadingError$" />
				</stages-popup-content>
				<stages-popup-footer [hasCancelButton]="false" [buttons]="buttons" />
			}
		} @else {
			@if (!credentialsValid && !oAuthUrl) {
				<stages-files-auth-embeddable #auth [cmsTypeMessageKey]="cmsTypeMessageKey!" />
			}
			@if (!credentialsValid && oAuthUrl) {
				<stages-files-oauth-embeddable-confirm
					[cmsTypeMessageKey]="cmsTypeMessageKey!"
					[authUrl]="oAuthUrl"
					[closeCallback]="close"
				/>
			}
		}
	</stages-dialog2>
}
